<form nz-form class="form" nzLayout="vertical">
  <div class="drawer-with-margin">
    <nz-tabset>
      <nz-tab nzTitle="Organizations">
        <app-import-organizations />
      </nz-tab>
      <nz-tab nzTitle="OneRoster File"><app-import-one-roster-file /> </nz-tab>
      <nz-tab nzTitle="OneRoster Job Manually">
        <app-import-one-roster-job />
      </nz-tab>
    </nz-tabset>
  </div>
</form>
